import {
  LocaleData,
  arLocale,
  bgLocale,
  caLocale,
  csLocale,
  daLocale,
  deLocale,
  esDoLocale,
  esLocale,
  esUsLocale,
  esPrLocale,
  etLocale,
  faLocale,
  fiLocale,
  frLocale,
  glLocale,
  frCaLocale,
  heLocale,
  hiLocale,
  hrLocale,
  huLocale,
  itLocale,
  zhCnLocale,
  ptBrLocale,
  enGbLocale
} from 'ngx-bootstrap/chronos';

export class NgxBootstrapLocaleMappingService {
  map(locale: string): string {
    const cultureMap: Record<string, string> = {
      'zh-Hans': 'zh-cn',
      'es-MX': 'es',
      'vi': 'en-gb',
      'ta': 'en-gb'
      // Add more here
    };

    if (locale === 'en' || locale.startsWith('en-')) {
      return 'en-gb';
    }

    if (cultureMap[locale]) {
      return cultureMap[locale];
    }

    return locale;
  }

  getModuleName(locale: string): string {
    const moduleNameMap: Record<string, string> = {
      'zh-Hans': 'zhCn',
      'es-MX': 'es',
      'pt-BR': 'ptBr',
      'vi': 'enGb',
      'ta': 'enGb'
      // Add more here
    };

    if (locale === 'en' || locale.startsWith('en-')) {
      return 'enGb';
    }

    if (moduleNameMap[locale]) {
      return moduleNameMap[locale];
    }

    return locale;
  }

  getLocale(locale: string): LocaleData {
    const moduleLocaleMap: Record<string, LocaleData> = {
      'zh-cn': zhCnLocale,
      'es': esLocale,
      'pt-BR': ptBrLocale,
      'en-gb': enGbLocale
      // Add more here
    };
    return moduleLocaleMap[locale] || enGbLocale;
  }
}
